import { type ReactElement } from "react";
import { BrandCodeEnum } from "src/graphql/generated/types";
import { useBrandStore } from "src/stores/brand-store";

import { type ConsentFormProps } from "./consent-form.types";
import { EssetConsentForm } from "./esset-consent-form";
import { FonciaConsentController } from "./foncia-consent-form/foncia-consent-controller";

export function ConsentPlatformGate({
  isOpen,
  isPending,
  onSubmit,
}: ConsentFormProps): ReactElement {
  const brandCode = useBrandStore((state) => state.brandCode);

  switch (brandCode) {
    case BrandCodeEnum.Foncia:
      return <FonciaConsentController isOpen={isOpen} />;

    case BrandCodeEnum.Esset:
      return (
        <EssetConsentForm
          isOpen={isOpen}
          isPending={isPending}
          onSubmit={onSubmit}
        />
      );

    default:
      return assertNeverBrand(brandCode);
  }
}

function assertNeverBrand(brandCode: never): never {
  throw new Error(`Unsupported consent form brand: ${String(brandCode)}`);
}
